export default __webpack_public_path__ + "static/media/7.61efc8af.png";